import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
interface Worktable {
  id: string;
  name: string;
}
@Component({
  selector: 'app-work-table',
  templateUrl: './work-table.component.html',
  styleUrl: './work-table.component.scss',
})
export class WorkTableComponent implements OnInit {
  @Input() drawingMode: boolean = false;
  @Input() worktables: any = [];
  @Output() draw = new EventEmitter<void>();
  @Output() delete = new EventEmitter<string>();
  isExpanded = false;
  ngOnInit(): void {}

  toggleExpand(): void {
    this.isExpanded = !this.isExpanded;
  }

  addWorktable(): void {
    this.draw.emit();
  }

  deleteWorktable(worktable: any): void {
    this.delete.emit(worktable);
  }

  trackById(index: number, item: any): any {
    return item.id;
  }
}
